import styles from "./HeaderText.module.scss";

type HeaderTextProps = {
  isH1TagDisabled?: boolean;
  title?: React.ReactNode;
  subtitle?: string;
};

export const HeaderText = ({ title, isH1TagDisabled = false, subtitle }: HeaderTextProps) => {
  const TitleTag = isH1TagDisabled ? "h2" : "h1";
  const SubtitleTag = isH1TagDisabled ? "h3" : "h2";

  return (
    <>
      {title && <TitleTag className={styles.title}>{title}</TitleTag>}
      {subtitle && <SubtitleTag className={styles.subtitle}>{subtitle}</SubtitleTag>}
    </>
  );
};
